import { Component } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Route error:", error, info);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center px-6 bg-[#F8FAFC]" data-testid="error-boundary">
        <div className="max-w-md text-center">
          <div className="w-14 h-14 mx-auto rounded-full bg-amber-100 text-amber-700 flex items-center justify-center mb-5">
            <AlertTriangle className="w-6 h-6" />
          </div>
          <h1 className="font-outfit text-3xl font-bold text-slate-900 mb-3">Something broke</h1>
          <p className="text-slate-600 mb-6 text-sm">
            We hit an unexpected error. The map data is fine — just this page failed to render.
          </p>
          <pre className="text-[11px] text-slate-400 bg-slate-100 rounded p-3 mb-6 overflow-x-auto text-left">
            {String(this.state.error?.message || this.state.error || "Unknown error")}
          </pre>
          <div className="flex items-center gap-2 justify-center">
            <Button onClick={this.reset} variant="outline" data-testid="error-retry-btn">Try again</Button>
            <Button asChild data-testid="error-home-btn" className="bg-slate-900 hover:bg-slate-800 text-white">
              <Link to="/map"><Home className="w-4 h-4 mr-2" /> Open map</Link>
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
